export default __webpack_public_path__ + "static/media/avatar.e2185f5b.png";